/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';
import Autocomplete from '@mui/material/Autocomplete';

import { Field, getIn } from 'formik';
import { CircularProgress, TextField } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

const RenderFormSelectAutocomplete = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  tooltip,
  children,
  dataSource,
  isLoading,
  placeholder,
  getSuggestionLabel,
  onChangeCallback,
  ...others
}) => {
  const { classes } = useStyles();
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  return (
    <Autocomplete
      options={dataSource}
      value={field.value ?? null}
      onChange={(event, value) => {
        if (onChangeCallback) {
          onChangeCallback(value);
        }
        setFieldValue(field.name, value);
      }}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => (option ? getSuggestionLabel(option) : '')}
      loadingText="Carregando..."
      loading={isLoading}
      noOptionsText="Nenhuma opção encontrada."
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          InputLabelProps={{
            shrink: true,
          }}
          variant="standard"
          InputProps={{
            autoComplete: 'off',
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={touch && error != null}
          helperText={touch && error}
          className={classes.formControl}
        />
      )}
      {...others}
    />
  );
};

RenderFormSelectAutocomplete.defaultProps = {
  placeholder: null,
  label: null,
  getSuggestionLabel: (opt) => opt.name,
};

RenderFormSelectAutocomplete.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  getSuggestionLabel: PropTypes.func,
};

export const FormSelectAutocomplete = ({ name, dataSource, ...others }) => (
  <Field name={name} component={RenderFormSelectAutocomplete} dataSource={dataSource} {...others} />
);
